// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const CheckmarkCircle2Fill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 4c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm-1.6 12-4-4 1.128-1.128 2.872 2.864 6.072-6.072L17.6 8.8 10.4 16Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const CheckmarkCircle2FillOffset: IconOffset = {
    vertical: 16, // Store Custom Code
    horizontal: 16, // Store Custom Code
};

export default React.memo(CheckmarkCircle2Fill);
